<template>

   
    <div class="row h-100" >
      <div class="col-md-4 py-5 h-100">
       
          <div class="card px-3 py-4 box-shadow h-100  overflow-hidden">

            <span v-for="n in notifications" :key="n.id">
              <div class="row">
                <div class="col-auto">
                  <b-avatar
                    :size="12"
                    :variant="notificationVariant(n.level)"
                    text="."
                  ></b-avatar>
                </div>
                <div class="col">
                  <h5 class="m-0 p-0">{{ n.message }}</h5>
                  <small class="text-muted font-size-11">
                    {{
                      moment(new Date(n.created_at)).format("DD MMM YY, HH:mm")
                    }}
                  </small>
                </div>
                <div class="col-auto">
                  <b-badge
                    v-if="n.job_number"
                    variant="primary"
                    class="float-right no-round text-monospace font-size-19 px-2 py-1"
                    >{{ n.job_number }}</b-badge
                  >
                </div>
              </div>

              <hr />
            </span>
          </div>
        
      </div>
      <div class="col-md-8 h-100 pt-5">
        <!-- Staff -->
        <div class="row h-100">
          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ unreadMessages }}
                    </h1>
                  </div>
                  <div class="col-auto text-right font-size-26">
                    <i class="lni lni-comments" :class="{
                        'text-success': unreadMessages == 0,
                        'text-danger': unreadMessages > 0,
                      }"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Unread<br> Messages</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                      
                    >
                      {{ inboundAwaitingWaybill }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-ship font-size-26 " :class="{
                        'text-success': inboundAwaitingWaybill == 0,
                        'text-danger': inboundAwaitingWaybill > 0,
                      }"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Inbound<br> Awaiting Waybill</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ outboundAwaitingWaybill }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-ship font-size-26"  :class="{
                        'text-success': outboundAwaitingWaybill == 0,
                        'text-danger': outboundAwaitingWaybill > 0,
                      }"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Outbound<br> Awaiting Waybill</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                      
                    >
                      {{ techAllocation }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-shovel  font-size-26" :class="{
                        'text-success': techAllocation == 0,
                        'text-danger': techAllocation > 0,
                      }"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Technician <br> Allocation</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1
                      class="font-weight-bold text-monospace"
                     
                    >
                      {{ quotationReview }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-calculator font-size-26"  :class="{
                        'text-success': quotationReview == 0,
                        'text-danger': quotationReview > 0,
                      }"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Quotation<br> Review</p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h1 class="font-weight-bold text-monospace">
                      {{ currentJobs }}
                    </h1>
                  </div>
                  <div class="col-auto">
                    <i class="lni lni-laptop-phone text-primary font-size-26"></i>
                  </div>
                </div>

                <p class="font-weight-bold font-size-19">Current<br> Jobs</p>
              </div>
            </div>
          </div>

          <div class="col-12  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <h1 class="font-weight-bold text-monospace">
                      {{ inbound }}
                    </h1>
                    <p class="font-weight-bold font-size-19">Inbound <br> transit</p>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col">
                        <h1
                          class="font-weight-bold text-monospace"
                        >
                          {{ outbound }}
                        </h1>
                      </div>
                      <div class="col-auto">
                        <i class="lni lni-ship text-primary font-size-26"></i>
                      </div>
                    </div>

                    <p class="font-weight-bold font-size-19">Outbound <br> transit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


            <div class="col-12  h-25">
            <div class="card box-shadow ">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <h1 class="font-weight-bold text-monospace">
                      {{ repairedToday }}
                    </h1>
                    <p class="font-weight-bold font-size-19">Repaired<br> today</p>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col">
                        <h1
                          class="font-weight-bold text-monospace"
                        >
                          {{ repairedMonth }}
                        </h1>
                      </div>
                     
                    </div>

                    <p class="font-weight-bold font-size-19">Repaired<br> month</p>
                  </div>
                   <div class="col-md-4">
                    <div class="row">
                      <div class="col">
                        <h1
                          class="font-weight-bold text-monospace"
                        >
                          {{ repairedYear }}
                        </h1>
                      </div>

                      <div class="col-auto">
                        <i class="lni lni-react text-primary font-size-26"></i>
                      </div>
                     
                    </div>

                    <p class="font-weight-bold font-size-19">Repaired <br>year</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import reportRepo from "@/api/repos/reportRepo";

export default {
  components: {
  
  },
  data() {
    return {    
      timer:null,
      unreadMessages: 0,
      inboundAwaitingWaybill: 0,
      outboundAwaitingWaybill: 0,
      techAllocation: 0,
      quotationReview: 0,
      inbound: 0,
      outbound: 0,
      currentJobs: 0,
      notifications: [],
      repairedToday:0,
      repairedMonth:0,
      repairedYear:0,
      
     
    };
  },

  mounted() {

    this.getData();
    this.timer = setInterval(this.getData, 60000);
  },

  methods: {
    notificationVariant(level) {
      if (level == 1) {
        return "success";
      } else if (level == 2) {
        return "info";
      } else if (level == 3) {
        return "warning";
      } else {
        return "danger";
      }
    },
    async getData() {
     
    
      try{
        let { data } = await reportRepo.dashboard();
        this.unreadMessages = data.unread_messages;
        this.inboundAwaitingWaybill = data.inbound_awaiting_waybill;
        this.outboundAwaitingWaybill = data.outbound_awaiting_waybill;
        this.techAllocation = data.tech_allocation;
        this.quoationReview = data.quotation_review;
        this.inbound = data.inbound;
        this.outbound = data.outbound;
        this.currentJobs = data.current_jobs;
        this.notifications = data.notifications;
        this.repairedToday = data.repaired_today
        this.repairedMonth = data.repaired_month
        this.repairedYear = data.repaired_year
      }catch(e){
         if (this.timer) clearInterval(this.timer);
      }
       
        
    

    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    next();
  },

 
};
</script>

<style scoped>
body,html {
  overflow: hidden;
}
</style>
